
import { useCallback } from 'react';
import { MetaEventType, EventParams, trackMetaEvent } from '../utils/metaTracking';

export const useMetaTracking = () => {
  // Função para rastrear eventos de lead
  const trackLead = useCallback((params: EventParams = {}) => {
    return trackMetaEvent('Lead', params);
  }, []);
  
  // Função para rastrear eventos de registro completo
  const trackCompleteRegistration = useCallback((params: EventParams = {}) => {
    return trackMetaEvent('CompleteRegistration', params);
  }, []);
  
  // Função para rastrear eventos de contato
  const trackContact = useCallback((params: EventParams = {}) => {
    return trackMetaEvent('Contact', params);
  }, []);
  
  // Função para rastrear eventos de agendamento
  const trackSchedule = useCallback((params: EventParams = {}) => {
    return trackMetaEvent('Schedule', params);
  }, []);
  
  // Função para rastrear eventos de início de trial
  const trackStartTrial = useCallback((params: EventParams = {}) => {
    return trackMetaEvent('StartTrial', params);
  }, []);
  
  // Função para rastrear eventos de submissão de aplicação
  const trackSubmitApplication = useCallback((params: EventParams = {}) => {
    console.log('[MetaTracking] SubmitApplication event tracked with params:', params);
    return trackMetaEvent('SubmitApplication', params);
  }, []);
  
  // Função para rastrear visualizações de conteúdo
  const trackViewContent = useCallback((params: EventParams = {}) => {
    return trackMetaEvent('ViewContent', params);
  }, []);
  
  // Função genérica para rastrear qualquer evento
  const trackEvent = useCallback((eventName: MetaEventType, params: EventParams = {}) => {
    return trackMetaEvent(eventName, params);
  }, []);
  
  return {
    trackLead,
    trackCompleteRegistration,
    trackContact,
    trackSchedule,
    trackStartTrial,
    trackSubmitApplication,
    trackViewContent,
    trackEvent,
  };
};

export default useMetaTracking;
